export default __webpack_public_path__ + "static/media/10.53ba6524.webp";